var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", [
    _c("div", { attrs: { id: "sitemap" } }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-3 col-md-3" }, [
            _c("h4", [_vm._v("Arrecadação")]),
            _vm._v(" "),
            _c("ul", [
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/about", href: "" } }, [
                    _vm._v("Como funciona")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/create-project", href: "" } },
                    [_vm._v("Cadastre sua ONG")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/about", href: "" } }, [
                    _vm._v("Quem somos")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-6 col-md-6" }, [
            _c("h4", [_vm._v("Categorias")]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "ul",
                  [
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          { attrs: { to: "/projects", href: "" } },
                          [_vm._v("Todos")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.col1, function(c) {
                      return _c("li", { key: c.CategoryId }, [
                        _c("a", { attrs: { href: "/projects/" + c.url } }, [
                          _vm._v(_vm._s(c.name))
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "ul",
                  _vm._l(_vm.col2, function(c) {
                    return _c("li", { key: c.CategoryId }, [
                      _c("a", { attrs: { href: "/projects/" + c.url } }, [
                        _vm._v(_vm._s(c.name))
                      ])
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "ul",
                  _vm._l(_vm.col3, function(c) {
                    return _c("li", { key: c.CategoryId }, [
                      _c("a", { attrs: { href: "/projects/" + c.url } }, [
                        _vm._v(_vm._s(c.name))
                      ])
                    ])
                  }),
                  0
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-3 col-md-3" }, [
            _c("h4", [_vm._v("Contato")]),
            _vm._v(" "),
            _c("ul", [
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/terms-and-conditions", href: "" } },
                    [_vm._v("Termos de Uso")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/privacy-policy", href: "" } },
                    [_vm._v("Política de Privacidade")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2)
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(3)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href:
              "https://click2giv.helpscoutdocs.com/article/41-politica-de-cancelamento",
            target: "_blank"
          }
        },
        [_vm._v("Política de Cancelamento")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "https://click2giv.helpscoutdocs.com",
            target: "_blank"
          }
        },
        [_vm._v("Perguntas Frequentes")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "https://click2giv.helpscoutdocs.com",
            target: "_blank"
          }
        },
        [_vm._v("Entre em Contato")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "copyright" } }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("span", { staticClass: "row" }, [
              _vm._v(
                "Click2giv Serviços Online Ltda. - CNPJ 24.636.206/0001-70"
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "row" }, [
              _vm._v(
                "Alameda Santos, 905 - 8 andar, sala 7 - Cerqueira César - São Paulo/SP"
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "row" }, [
              _vm._v("✉ meajuda.suporte@click2giv.com - "),
              _c("b", [_vm._v("☎ (11) 98741-1000")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5690fbc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5690fbc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/includes/Footer.vue
// module id = null
// module chunks = 